import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={13} height={20} fill="#fff" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M2.045 16.031l7.568-6.054-7.568-6.054v12.108zM1.662.997l10.227 8.182c.512.409.512 1.187 0 1.597L1.662 18.958A1.023 1.023 0 010 18.159V1.795C0 .938.992.461 1.662.997z" /></svg>;
}
export default SvgComponent;